import JSONPretty from 'react-json-pretty';

export default {
  className: "ApiLogs",
  limit: 10,
  showExport: false,
  showCreate: false,
  showUpdate: false,
  showDelete: false,
  bypassAccess: true,
  columns: [
    {
      columnName: "objectId",
  		type: "string"
    },
    {
      columnName: "endPoint",
      columnLabel: 'end point',
  		type: "string"
    },
    {
      columnName: "apiKey",
      columnLabel: 'api Key',
  		type: "string"
    },
    {
      columnName: "networkIp",
      columnLabel: 'network Ip',
  		type: "string"
    },
    {
      columnName: "params",
      columnLabel: 'parameter',
  		type: "custom",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('params')) {
          value = JSON.stringify(object.get('params'));

          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "response",
  		type: "custom",
      render: ({
        value,
        column,
        getTableData,
        object
      }) => {
        let renderValue = "";

        if (object.get('response')) {
          value = JSON.stringify(object.get('response'));

          renderValue = value.substr(0, 50).trim() + (value.length <= 50 ? "" : "...");
        }

        return renderValue;
      }
    },
    {
      columnName: "createdAt",
      columnLabel: "Date",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A",
      show: true
    },
    {
      columnName: "updatedAt",
  		type: "Date",
      format: "MM/DD/YYYY hh:mm:ss A"
    }
  ]
}


// WEBPACK FOOTER //
// ./components/Logs/APILogs_schema.js